import { parse } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

class Conversiones {
  static stringToStringFecha(
    fecha: string,
    inputFormat: string = 'dd-MM-yyyy',
    dias?: number | undefined,
    meses?: number | undefined,
    years?: number | undefined,
  ): string | undefined {
    let date: Date

    if (inputFormat === 'yyyy-MM-dd') {
      const [year, month, day] = fecha.split('-').map(Number)
      date = new Date(Date.UTC(year, month - 1, day))
    } else if (inputFormat === 'dd-MM-yyyy') {
      const [day, month, year] = fecha.split('-').map(Number)
      date = new Date(Date.UTC(year, month - 1, day))
    } else {
      console.log('Formato invalido')
      return
    }

    if (dias) {
      date.setUTCDate(date.getUTCDate() + dias)
    }

    if (years) {
      date.setUTCFullYear(date.getUTCFullYear() + years)
    }

    if (meses) {
      date.setUTCMonth(date.getUTCMonth() + meses)
    }

    const result = date.toISOString().split('T')[0]
    return result
  }

  /**
   * Convierte una fecha sea de tipo Date o string en un string con formato fecha yyyy-MM-dd HH:mm:ss, es utilizado para los input con el componente fecha.
   * @param {Date | string} fecha Una fecha de tipo Date o string.
   * @param {string | undefined} inputFormat si es de tipo string se debe especificar el formato de la fecha.
   * @param {number | undefined} days parametro para agregarle dias a la fecha.
   * @return {string|undefined} La fecha convertida en formato "yyyy-MM-dd".
   */
  static fechaToStringInput(
    fecha: Date | string,
    inputFormat?: string,
    days?: number | undefined,
  ): string | undefined {
    if (fecha instanceof Date) {
      const zonedDate = utcToZonedTime(fecha, 'America/Santiago')
      if (days) {
        zonedDate.setDate(zonedDate.getDate() + days)
      }
      const day = String(zonedDate.getDate()).padStart(2, '0')
      const month = String(zonedDate.getMonth() + 1).padStart(2, '0')
      const year = String(zonedDate.getFullYear())
      return `${year}-${month}-${day}`
    } else if (typeof fecha === 'string' && inputFormat) {
      const parsedDate = parse(fecha, inputFormat, new Date())
      const zonedDate = utcToZonedTime(parsedDate, 'America/Santiago')
      if (days) {
        zonedDate.setDate(zonedDate.getDate() + days)
      }
      const day = String(zonedDate.getDate()).padStart(2, '0')
      const month = String(zonedDate.getMonth() + 1).padStart(2, '0')
      const year = String(zonedDate.getFullYear())
      return `${year}-${month}-${day}`
    }
  }

  /**
   * Convierte una fecha de tipo string con un formato dd-MM-yyyy'T'HH:mm:ss a Date.
   * @param {string} fecha - un string con formato dd-MM-yyyy'T'HH:mm:ss.
   * @return {Date|undefined} la fecha convertida de tipo Date.
   */

  static stringToFecha(
    fecha: string,
    inputFormat: string = "dd-MM-yyyy'T'HH:mm:ss",
  ): Date | undefined {
    if (typeof fecha === 'string') {
      const parsedDate = parse(fecha, inputFormat, new Date())
      const zonedDate = utcToZonedTime(parsedDate, 'America/Santiago')
      return zonedDate
    }
  }

  /**
   * Convierte una fecha de tipo string con un formato dd-MM-yyyy'T'HH:mm:ss a una fecha de tipo string a un formato dd/MM/yyyy, se ocupa para mostrar las fechas en las tablas.
   * @param {string} fecha - un string con formato dd-MM-yyyy'T'HH:mm:ss.
   * @return {string|undefined} un string con formato dd/MM/yyyy
   */

  static fechaCorta(fecha: string | Date): string | undefined {
    if (typeof fecha === 'string') {
      const inputFormat = "dd-MM-yyyy'T'HH:mm:ss"
      const parsedDate = parse(fecha, inputFormat, new Date())
      const zonedDate = utcToZonedTime(parsedDate, 'America/Santiago')
      const day = String(zonedDate.getDate()).padStart(2, '0')
      const month = String(zonedDate.getMonth() + 1).padStart(2, '0')
      const year = String(zonedDate.getFullYear())
      return `${day}/${month}/${year}`
    } else if (fecha instanceof Date) {
      const zonedDate = utcToZonedTime(fecha, 'America/Santiago')
      const day = String(zonedDate.getDate()).padStart(2, '0')
      const month = String(zonedDate.getMonth() + 1).padStart(2, '0')
      const year = String(zonedDate.getFullYear())
      return `${day}/${month}/${year}`
    }
  }

  static fechaCortaFormat(fecha: string, format?: string): string {
    if(!fecha)
      return ''

    const inputFormat = format || "yyyy-MM-dd'T'HH:mm:ss"
    const parsedDate = parse(fecha.split('.')[0], inputFormat, new Date())
    const zonedDate = utcToZonedTime(parsedDate, 'America/Santiago')
    const day = String(zonedDate.getDate()).padStart(2, '0')
    const month = String(zonedDate.getMonth() + 1).padStart(2, '0')
    const year = String(zonedDate.getFullYear())
    return `${day}/${month}/${year}`
  }

  static fechaConHora(fecha: string): string | undefined {
    if (typeof fecha === 'string') {
      const inputFormat = 'yyyy-MM-dd'
      const parsedDate = parse(fecha, inputFormat, new Date())
      const zonedDate = utcToZonedTime(parsedDate, 'America/Santiago')
      const day = String(zonedDate.getDate()).padStart(2, '0')
      const month = String(zonedDate.getMonth() + 1).padStart(2, '0')
      const year = String(zonedDate.getFullYear())
      return `${day}-${month}-${year}T12:00:00`
    }
  }

  static fechaConHoraFormat(fecha: string, format?: string): string {
    const inputFormat = format || "yyyy-MM-dd'T'HH:mm:ss"
    const parsedDate = parse(fecha.split('.')[0], inputFormat, new Date())
    const zonedDate = utcToZonedTime(parsedDate, 'America/Santiago')
    const day = String(zonedDate.getDate()).padStart(2, '0')
    const month = String(zonedDate.getMonth() + 1).padStart(2, '0')
    const year = String(zonedDate.getFullYear())
    const hours = String(zonedDate.getHours()).padStart(2, '0')
    const minutes = String(zonedDate.getMinutes()).padStart(2, '0')
    const seconds = String(zonedDate.getSeconds()).padStart(2, '0')
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
  }

  static compararFechas(date1: Date, date2: Date): boolean {
    if (!date1 || !date2) {
      return false
    }

    const isSameYear = date1.getFullYear() === date2.getFullYear()
    const isSameMonth = date1.getMonth() === date2.getMonth()
    const isSameDate = date1.getDate() === date2.getDate()

    return isSameYear && isSameMonth && isSameDate
  }

  static compararMesAño(date1: Date, date2: Date): boolean {
    if (!date1 || !date2) {
      return false
    }

    const isSameYear = date1.getFullYear() === date2.getFullYear()
    const isSameMonth = date1.getMonth() === date2.getMonth()

    return isSameYear && isSameMonth
  }

  static fechaStringConHora(fecha: string | Date): string | undefined {
    if (typeof fecha === 'string') {
      const inputFormat = "dd-MM-yyyy'T'HH:mm:ss"
      const parsedDate = parse(fecha, inputFormat, new Date())
      const zonedDate = utcToZonedTime(parsedDate, 'America/Santiago')
      const day = String(zonedDate.getDate()).padStart(2, '0')
      const month = String(zonedDate.getMonth() + 1).padStart(2, '0')
      const year = String(zonedDate.getFullYear())
      const hours = String(zonedDate.getHours()).padStart(2, '0')
      const minutes = String(zonedDate.getMinutes()).padStart(2, '0')
      const seconds = String(zonedDate.getSeconds()).padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
    } else if (fecha instanceof Date) {
      const zonedDate = utcToZonedTime(fecha, 'America/Santiago')
      const day = String(zonedDate.getDate()).padStart(2, '0')
      const month = String(zonedDate.getMonth() + 1).padStart(2, '0')
      const year = String(zonedDate.getFullYear())
      const hours = String(zonedDate.getHours()).padStart(2, '0')
      const minutes = String(zonedDate.getMinutes()).padStart(2, '0')
      const seconds = String(zonedDate.getSeconds()).padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
    }
  }

  static formatTimestamp(timestamp: string): string {
    let isNegative = timestamp.startsWith('-')
    let [time, fractions] = timestamp.replace('-', '').split('.')
    let [hours, minutes, seconds] = time.split(':')

    hours = hours || '0'
    minutes = minutes || '0'
    seconds = seconds || '0'

    let totalMinutes = +hours * 60 + +minutes + +seconds / 60

    let days = Math.floor(totalMinutes / (60 * 24))
    totalMinutes -= days * 60 * 24
    let newHours = Math.floor(totalMinutes / 60)
    totalMinutes -= newHours * 60
    let newMinutes = Math.floor(totalMinutes)

    let formattedTime = `${days} Dias, ${newHours
      .toString()
      .padStart(2, '0')} Horas, ${newMinutes
        .toString()
        .padStart(2, '0')} Minutos`

    return isNegative ? `-${formattedTime}` : formattedTime
  }

  static formatPeso(input: string | number): string {
    let inputStr = ''
    if (typeof input === 'string') {
      inputStr = input
    } else if (typeof input === 'number') {
      inputStr = input.toString()
    }
    const inputWithDot = inputStr
      .split('')
      .reverse()
      .join('')
      .replace(/(\d{3}(?!$))/g, '$1.')
      .split('')
      .reverse()
      .join('')
    return '$' + inputWithDot
  }

  /**
   * * separador de puntos para numeros con decimales como 10000.10 a 10.000,10
   * */
  static formatCientos(input: string | number, prefix = '', decimals = 2) {
    let inputStr = ''

    if (typeof input === 'number') {
      inputStr = input.toFixed(decimals)
    } else {
      const num = parseFloat(input.replace(',', '.'))
      if (!isNaN(num)) {
        inputStr = num.toFixed(decimals)
      } else {
        inputStr = input
      }
    }

    inputStr = inputStr.replace('.', ',')

    const parts = inputStr.split(',')

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')

    return `${prefix}${prefix ? ' ' : ''}${parts.join(',')}`
  }

  static fechaMesAño(fecha: string, format?: string): string {
    const inputFormat = format || "yyyy-MM-dd'T'HH:mm:ss"
    const parsedDate = parse(fecha.split('.')[0], inputFormat, new Date())
    const zonedDate = utcToZonedTime(parsedDate, 'America/Santiago')

    const monthsInSpanish = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ]

    const monthName = monthsInSpanish[zonedDate.getMonth()]
    const year = zonedDate.getFullYear().toString()

    return `${year} - ${monthName}`
  }

  static padTo2Digits(num: number) {
    return num.toString().padStart(2, '0')
  }

  static formatDate(date: Date, separator = "/") {
    let fechaFormated = [
      date.getDate().toString().padStart(2, '0'),
      (date.getMonth() + 1).toString().padStart(2, '0'),
      date.getFullYear(),
    ].join(separator)
    if (fechaFormated.includes("NaN")) fechaFormated = "";
    return fechaFormated
  }

  static formatDateReverse(date: Date, separator = "/") {
    let fechaFormated = [
      date.getFullYear(),
      (date.getMonth() + 1).toString().padStart(2, '0'),
      date.getDate().toString().padStart(2, '0'),  
    ].join(separator)
    if (fechaFormated.includes("NaN")) fechaFormated = "";
    return fechaFormated
  }

  static formatCurrentDate() {
    const date = new Date()
    return [
      date.getFullYear(),
      (date.getMonth() + 1).toString().padStart(2, '0'),
      date.getDate().toString().padStart(2, '0'),
    ].join('-')
  }
  static parseLocalDate = (dateStr?: string | null) => {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split('-').map(Number);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day);
  };

  static normalizarFecha = (date: Date) => {
    const f = new Date(date);
    f.setHours(0, 0, 0, 0);
    return f;
  }

  static pad = (n: number) => String(n).padStart(2, '0');

  static getTimestampNum = () => {
    const d = new Date(); // local time
    return (
      this.pad(d.getDate()) +
      this.pad(d.getMonth() + 1) +
      d.getFullYear() +
      this.pad(d.getHours()) +
      this.pad(d.getMinutes()) +
      this.pad(d.getSeconds())
    );
  };

}

export default Conversiones
